import colors from 'theme/colors';
import { StationIconProps } from './types';

export const SubZone = ({ background = colors.darkBlue, color = colors.white, ...rest }: StationIconProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
                fill={background}
            />
            <path
                d="M14.2217 9.7778C14.2217 10.7597 15.0177 11.5556 15.9995 11.5556C16.9814 11.5556 17.7773 10.7597 17.7773 9.7778C17.7773 8.79595 16.9814 8 15.9995 8C15.0177 8 14.2217 8.79595 14.2217 9.7778Z"
                fill={color}
                stroke={color}
            />
            <path
                d="M20.4444 22.2212C20.4444 23.203 21.2403 23.999 22.2222 23.999C23.2041 23.999 24 23.203 24 22.2212C24 21.2393 23.2041 20.4434 22.2222 20.4434C21.2403 20.4434 20.4444 21.2393 20.4444 22.2212Z"
                fill={color}
                stroke={color}
            />
            <path
                d="M14.2217 22.2212C14.2217 23.203 15.0177 23.999 15.9995 23.999C16.9814 23.999 17.7773 23.203 17.7773 22.2212C17.7773 21.2393 16.9814 20.4434 15.9995 20.4434C15.0177 20.4434 14.2217 21.2393 14.2217 22.2212Z"
                fill={color}
                stroke={color}
            />
            <path
                d="M8.00006 22.2212C8.00006 23.203 8.79601 23.999 9.77786 23.999C10.7597 23.999 11.5557 23.203 11.5557 22.2212C11.5557 21.2393 10.7597 20.4434 9.77786 20.4434C8.79601 20.4434 8.00006 21.2393 8.00006 22.2212Z"
                fill={color}
                stroke={color}
            />
            <path
                d="M9.77803 20.4428L9.77803 15.1094L22.2227 15.1094V20.4428"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16 11.5527V20.4418Z" fill={color} />
            <path d="M16 11.5527V20.4418" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
